import { RootState } from "../store";
import { bonEntityAdapter } from "./bon.slice";

export const bonSelector = bonEntityAdapter.getSelectors<RootState>((state) => state.bon);
export const { selectAll, selectIds } = bonSelector;
export const selectCreatedFromModal = (state: RootState) => state.bon.createdFromModal;


